import React from 'react';
import { Box, Alert } from '@spothero/ui';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
import { TOOLTIPS, useTooltips } from 'pages/search/hooks/use-tooltips';
const ToolTipSwitch = () => {
    const { isVisible: isTooltipVehicleVisible, text: tooltipVehicleText, handleClose: handleTooltipVehicleClose, } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const { isVisible: isTooltipLoyaltyVisible, text: tooltipLoyaltyText, handleClose: handleTooltipLoyaltyClose, } = useTooltips(TOOLTIPS.loyalty_program_popover);
    if (isTooltipLoyaltyVisible)
        return (<Alert description={tooltipLoyaltyText} onDismissClick={handleTooltipLoyaltyClose} showDismiss status="neutral" showIcon={false}/>);
    if (isTooltipVehicleVisible)
        return (<Alert description={tooltipVehicleText} onDismissClick={handleTooltipVehicleClose} showDismiss status="neutral" showIcon={false}/>);
    return null;
};
export const MobileFilterCallouts = () => {
    const { isVisible: isTooltipVehicleVisible } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const { isVisible: isTooltipLoyaltyVisible } = useTooltips(TOOLTIPS.loyalty_program_popover);
    const isMobile = useMobileBreakPoint();
    const isVisible = isMobile &&
        (isTooltipVehicleVisible || isTooltipLoyaltyVisible || false);
    return isVisible ? (<Box marginTop={2} marginBottom={4}>
            <ToolTipSwitch />
        </Box>) : null;
};
